export function toggleFullScreen() {
  const doc = document;
  const docEl = doc.documentElement;

  if (
    !doc.fullscreenElement &&
    // @ts-expect-error browser fallbacks
    !doc.webkitFullscreenElement &&
    // @ts-expect-error browser fallbacks
    !doc.mozFullScreenElement &&
    // @ts-expect-error browser fallbacks
    !doc.msFullscreenElement
  ) {
    if (docEl.requestFullscreen) {
      docEl.requestFullscreen();
      // @ts-expect-error browser fallbacks
    } else if (docEl.webkitRequestFullscreen) {
      // @ts-expect-error browser fallbacks
      docEl.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      // @ts-expect-error browser fallbacks
    } else if (docEl.mozRequestFullScreen) {
      // @ts-expect-error browser fallbacks
      docEl.mozRequestFullScreen();
      // @ts-expect-error browser fallbacks
    } else if (docEl.msRequestFullscreen) {
      // @ts-expect-error browser fallbacks
      docEl.msRequestFullscreen();
    }
  } else {
    if (doc.exitFullscreen) {
      doc.exitFullscreen();
      // @ts-expect-error browser fallbacks
    } else if (doc.webkitExitFullscreen) {
      // @ts-expect-error browser fallbacks
      doc.webkitExitFullscreen();
      // @ts-expect-error browser fallbacks
    } else if (doc.mozCancelFullScreen) {
      // @ts-expect-error browser fallbacks
      doc.mozCancelFullScreen();
      // @ts-expect-error browser fallbacks
    } else if (doc.msExitFullscreen) {
      // @ts-expect-error browser fallbacks
      doc.msExitFullscreen();
    }
  }
}
